import { useRef } from "react";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ImageFieldDef } from "./schema";

interface IImageFieldProps {
  field: ImageFieldDef;
  previewUrl: string | undefined;
  onChange: (file: File) => void;
  onClear: () => void;
}

export const ImageField = ({ field, previewUrl, onChange, onClear }: IImageFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 0.75 }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 1,
          border: "1px solid rgba(0,0,0,0.23)",
          backgroundColor: "rgba(0,0,0,0.04)",
          backgroundImage: previewUrl ? `url(${previewUrl})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          flexShrink: 0,
        }}
      />
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" fontWeight={600}>
          {field.label}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {field.helperText}
        </Typography>
      </Box>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onChange(file);
          e.target.value = "";
        }}
      />
      <Button size="small" variant="outlined" onClick={() => inputRef.current?.click()}>
        Replace
      </Button>
      <IconButton size="small" onClick={onClear} disabled={!previewUrl}>
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};
